/**
 * Parses an Active Directory Distinguished Name and extracts the OU hierarchy.
 *
 * Example input:
 *   "CN=John Doe,OU=Developers,OU=IT,OU=Paris,DC=company,DC=com"
 *
 * Returns OUs from broadest to most specific:
 *   ["Paris", "IT", "Developers"]
 */
export function parseOUs(dn: string | null | undefined): string[] {
  if (!dn) {
    return [];
  }
  const matches = dn.match(/(?:^|,)OU=([^,]+)/gi) ?? [];
  return matches.map((m) => m.replace(/^,?OU=/i, '').trim()).reverse(); // DN order is specific→broad; reverse to broad→specific
}

/** Returns a formatted OU path string, e.g. "Paris › IT › Developers" */
export function formatOU(dn: string | null | undefined): string {
  return parseOUs(dn).join(' › ');
}
